import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClient } from "../../tools/api-client";


export interface PdfTemplate {
  data: string;
}

export interface PatientFormTemplateSelector {
  language: string;
  measurementId: number;
}

@Injectable()
export class PdfDownloaderService {
  constructor(private apiClient: ApiClient) {
  }

  getPdfTemplate(patientFormTemplateSelector: PatientFormTemplateSelector): Observable<PdfTemplate> {
    return this.apiClient
      .get<PdfTemplate>("/api/measurements/form",
      {
        language: patientFormTemplateSelector.language,
        measurementId: `${patientFormTemplateSelector.measurementId}`
      });
  }
}
